import { render, staticRenderFns } from "./magazineView.vue?vue&type=template&id=2a731de6&scoped=true&"
import script from "./magazineView.vue?vue&type=script&lang=js&"
export * from "./magazineView.vue?vue&type=script&lang=js&"
import style0 from "./magazineView.vue?vue&type=style&index=0&id=2a731de6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a731de6",
  null
  
)

export default component.exports